import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgStarFilledIcon from './svgs/StarFilledIcon.js';
import { useIcon } from '../../shared-components/icon/index.js';

var starFilledIcon = (props => useIcon(SvgStarFilledIcon, SvgStarFilledIcon, props));

export { starFilledIcon as default };
